import React from 'react'
import { Risk } from '@trustero/trustero-api-web/lib/risk/risk_pb'
import { FlexRow, FlexAlign } from 'src/components/Reusable/Flex'
import { PopupButton } from 'src/components/Reusable/Buttons'
import { RISK_STATUS_LABEL } from 'src/pages/Risks/risks.constants'
import { Accordion } from 'src/components/Reusable/Accordions'
import { useCanPerformAction } from 'src/app/AppAuth/AppAuth.hooks'
import { CAPABILITY } from '@trustero/trustero-api-web/lib/authz/permissions_pb'
import {
  ShowPageBody,
  ShowPageItem,
  ShowPageItemBody,
  ShowPageItemGuidanceAndNotes,
} from '../../../components/PageLayout/ShowPage'
import {
  RiskSectionContainer,
  RiskSectionHeader,
  RiskMenuContent,
} from '../risks.styles'
import { AddControlsToRiskModal } from '../modals/AddControlsToRiskModal'
import { StatusMenu } from '../risks.components'
import { RiskLinkages } from './RisksLinkages'
import { RiskOverview } from './RisksOverview'
import { RisksResponse } from './RisksResponse'
import { RisksNotes } from './RisksNotes'
import { RisksTabs } from './RisksTabs'

export const RisksShowPageContent = ({ risk }: { risk: Risk }): JSX.Element => {
  const existingControlIds = risk.getControlIds().split(',')
  const riskId = risk.getId()
  const status = risk.getStatus()
  const riskObj = risk.toObject()
  const canUpdateStatus = useCanPerformAction<Risk.AsObject>(
    CAPABILITY.CAN_UPDATE_RISK_STATUS,
    riskObj,
  )
  return (
    <>
      <ShowPageItem>
        <ShowPageBody>
          <ShowPageItemGuidanceAndNotes>
            <RiskSectionContainer>
              <FlexRow
                justify={FlexAlign.FLEX_START}
                align={FlexAlign.CENTER}
                gap={8}
                isFullWidth
              >
                <PopupButton
                  label={`Status: ${RISK_STATUS_LABEL[status]}`}
                  menu={
                    <RiskMenuContent>
                      <StatusMenu risk={risk} />
                    </RiskMenuContent>
                  }
                  isDisabled={!canUpdateStatus}
                />
                <PopupButton
                  label="Linkages"
                  menu={
                    <RiskMenuContent>
                      <RiskLinkages risk={risk} />
                    </RiskMenuContent>
                  }
                />
              </FlexRow>
            </RiskSectionContainer>
            <RiskSectionContainer>
              <RiskSectionHeader>Risk</RiskSectionHeader>
              <RiskOverview risk={risk} />
            </RiskSectionContainer>
            <RiskSectionContainer>
              <RiskSectionHeader>Response</RiskSectionHeader>
              <RisksResponse risk={risk} />
            </RiskSectionContainer>
            <RiskSectionContainer>
              <Accordion label="Notes" defaultExpanded>
                <RisksNotes risk={risk} />
              </Accordion>
            </RiskSectionContainer>
          </ShowPageItemGuidanceAndNotes>
        </ShowPageBody>
        <ShowPageItemBody>
          <RisksTabs risk={risk} />
        </ShowPageItemBody>
      </ShowPageItem>
      {/* ----------- Modal(s) ----------- */}
      <AddControlsToRiskModal
        riskId={riskId}
        existingControlIds={existingControlIds}
      />
    </>
  )
}
